/**
 * Created by dx.yang on 2017/3/20.
 */


import * as commonConst from '../common/constants';
import * as avoidConst from './constants';
import * as avoidApis from '../../services/apis/avoid';


export default {
    [avoidConst.getAvoids](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.getAvoids);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(avoidConst.getAvoids, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.createAvoid](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.createAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.avoidCapacity](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.avoidCapacity);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.editAvoid](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.editAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.deleteAvoid](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.deleteAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.removeInstance](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.removeInstance);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [avoidConst.GetInstanceByIds](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.GetInstanceByIds);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },

    [avoidConst.QueryAvoid](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, avoidApis.QueryAvoid);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                let avoidRegion = [];
                let allRegions = _.filter(data.value, ['dataCenterId', '1']);
                // let allRegions = data.value;
                let list = allRegions[0]['regions'];
                _.map(list, (val, idx) => {
                    if (!commonConst.BasicRegionList(val.regionCode)) {
                        avoidRegion.push(list[idx]);
                    }
                });
                ctx.commit(commonConst.regionList, avoidRegion);
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    }
};

